/***************************************************************************************************
** TODO: Rethink
** useFormConfig
***************************************************************************************************/

import { useState } from "react";
import { useDeepCompareEffect } from "react-use";
import { slice } from "@utils";

const FIELD_VALIDATION_TYPE_NAMES = [
  "isRequired",
  "isDisabled",
  "hasEmailFormat",
  "hasUrlFormat",
];

// const defaultProps = {
//   fields: [],
//   data: {},
// };

export default function useFormConfig({ fields, data }) {
  fields ||= [];
  data ||= {};

  fields = fields.flat();

  const defaultInitialFormValues = data;

  /**************************************************************************************************/

  const [initialFormValues, setInitialFormValues] = useState(data);

  useDeepCompareEffect(() => {
    setInitialFormValues(data);
  }, [data]);

  /**************************************************************************************************/

  const fieldValidations = {};

  fields.forEach((field) => {
    fieldValidations[field.name] = slice(field.config, FIELD_VALIDATION_TYPE_NAMES);
  });

  /**************************************************************************************************/

  return {
    defaultInitialFormValues,
    initialFormValues,
    setInitialFormValues,

    fieldValidations,
  };
}
